import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ProductSpecification } from '../../../../../core';

@JsonConverter
export class ProductSpecificationAdapter implements JsonCustomConvert<ProductSpecification> {
    serialize(level: ProductSpecification): any {
        switch (level) {
            case ProductSpecification.MODERATE:
                return 2;
            case ProductSpecification.VERY_HIGH:
                return 3;
            default:
                return 1;
        }
    }

    deserialize(level: any): ProductSpecification {
        switch (level) {
            case 2:
                return ProductSpecification.MODERATE;
            case 3:
                return ProductSpecification.VERY_HIGH;
            default:
                return ProductSpecification.LOW;
        }
    }
}
